import React from "react";
import { SHOW_TOAST } from "app/layout/constants";
import { TooltipToaster } from "app/toaster";
import { Intent } from "@blueprintjs/core";
import { DISMISS_TOAST } from "./constants";

const showTooltip = info => {
  const { message } = info;
  const toast = {
    iconName: "info-sign",
    message: <span>Hint: {message}</span>,
    intent: Intent.PRIMARY,
    timeout: 100000000
  };
  return TooltipToaster.show(toast);
};

const showToast = message => {
  return showTooltip({ message });
};

export const toastMiddleware = store => next => action => {
  let toastId;
  switch (action.type) {
    case SHOW_TOAST:
      toastId = store.getState().layout.toastId;
      if (toastId) TooltipToaster.dismiss(toastId);

      toastId = showToast(action.message);
      action.toastId = toastId;
      return next(action);
    case DISMISS_TOAST:
      toastId = store.getState().layout.toastId;
      if (toastId) TooltipToaster.dismiss(toastId);
      return next(action);
    default:
      // console.log(action);
      return next(action);
  }
};



// WEBPACK FOOTER //
// ./src/app/layout/middleware.js